import { PrimaryButton } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { AuthHeader } from "./AuthHeading";

export function AccountDeletedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate("/");
  };

  return (
    <>
      <AuthHeader
        title={t("Your Certn account is now deleted")}
        subtitle={t(
          "We're sorry to see you go, but we hope to see you again some day."
        )}
      />

      <PrimaryButton
        fullWidth
        type="button"
        size="large"
        onPress={handleOnClick}
        testID="account-delete-page-sign-up-button"
      >
        {t("Sign up to Certn")}
      </PrimaryButton>
    </>
  );
}
